import {AppConfig} from '../utils/config'

const initialState = AppConfig;

const MapReducer = (state = initialState, action) => {
    let layers = state.layers;
    switch (action.type) {
        case "CHANGE_ZOOM":
            return {
                ...state,
                zoom: action.payload
            };
        case "CHANGE_COLORRAMP":
            return {
                ...state,
                colorRamp: action.payload
            };
        case "UPDATE_SLD":
            layers[action.payload.layerId] = {
                ...layers[action.payload.layerId],
                sldBody: action.payload.sldBody
            }
            return {
                ...state,
                layers: layers,
                styleData: action.payload.styleData
            };
        case "SET_ACTIVE_FIELD":
            return {
                ...state,
                activeField: action.payload
            }
        
        case "UPDATE_BMS":
            return {
                ...state,
                enabledBmaps: action.payload
            }
        case "TOGGLE_LAYER_STATE":
            Object.keys(layers).map(k=>{
                if(k==="allum_project:basemap"){
                    return;
                }
                if(k===action.payload.layerId){
                    layers[k].active = true;
                }else{
                    layers[k].active = false;
                }
            })
            return {
                ...state,
                layers: layers,
                activeLayer: action.payload.layerId
            }
        default:
            return {
                ...state
            };
    }
};

export default MapReducer;